var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrePurchaseInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.334 25.853v17.561h-7.108a.784.784 0 0 1-.58-.258l-1.368-1.498H7.707a2.377 2.377 0 0 1-2.346-1.931L4 32.446a6.592 6.592 0 0 1 6.593-6.593h14.741z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.334 14.709v11.144H9.184l3.196-6.671a7.875 7.875 0 0 1 7.104-4.473h5.85zM25.334 32.058v5.365h-4.3a.356.356 0 0 1-.27-.121l-3.99-4.665a.351.351 0 0 1 .267-.579h8.293zM5.255 37.267h9.866a.543.543 0 0 0 .352-.958l-4.88-4.126a.536.536 0 0 0-.344-.129l-5.776-.058M6.553 41.654h9.111V44a1.979 1.979 0 0 1-1.978 1.978H8.532A1.978 1.978 0 0 1 6.553 44v-2.346zM10.045 23.518v-.43H6.092A1.214 1.214 0 0 0 4.876 24.3v1.228a.747.747 0 0 0 .747.747h2.46",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.096 25.145a1.619 1.619 0 0 1 1.235 2.663l-5.893 6.92a1.623 1.623 0 0 1-2.448.418l-2.768-2.345a1.619 1.619 0 0 1 1.052-2.85 1.6 1.6 0 0 1 1.048.39l1.513 1.29 5.033-5.911a1.616 1.616 0 0 1 1.231-.567l-.003-.008zm.004-1.165a2.768 2.768 0 0 0-2.124.981l-4.258 5.009-.622-.532a2.792 2.792 0 0 0-3.617 4.255l2.769 2.346a2.792 2.792 0 0 0 4.16-.626l5.834-6.85a2.788 2.788 0 0 0-2.127-4.6l-.016.017z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.294 46.366h-15.18a2.706 2.706 0 0 1-2.71-2.706V15.256a2.737 2.737 0 0 1 .677-1.787l7.527-8.56a2.71 2.71 0 0 1 4.051 0l7.653 8.572c.444.495.689 1.137.688 1.803V43.68a2.706 2.706 0 0 1-2.706 2.686z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.704 10.775a2.06 2.06 0 1 0 0-4.122 2.06 2.06 0 0 0 0 4.122z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.215 14.982h3.625M33.87 14.982h3.621M40.475 14.982h3.62",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrePurchaseInspection);
export default __webpack_public_path__ + "static/media/pre-purchase-inspection.26617718714432e14575bd5c66272e9c.svg";
export { ForwardRef as ReactComponent };